module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.sku !== null) ? _c('modal', {
    model: {
      value: (_vm.isVisible),
      callback: function($$v) {
        _vm.isVisible = $$v
      },
      expression: "isVisible"
    }
  }, [_c('div', {
    staticClass: "c-modalCard"
  }, [_c('header', {
    staticClass: "c-modalCard__header"
  }, [_c('h4', {
    staticClass: "c-modalCard__title"
  }, [_vm._v("Histórico de alterações manuais de preços.")]), _vm._v(" "), _c('a', {
    staticClass: "c-modalCard__close",
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        _vm.isVisible = false
      }
    }
  }, [_c('i', {
    staticClass: "i-remove"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "c-modalCard__body"
  }, [(_vm.priceHistory.length) ? _c('ul', {
    staticClass: "c-stream"
  }, _vm._l((_vm.priceHistory), function(history) {
    return _c('li', {
      key: history,
      staticClass: "c-stream__item"
    }, [_c('span', {
      staticClass: "c-stream__badge hint error",
      attrs: {
        "data-label": "Alteração de preço"
      }
    }), _vm._v(" "), _c('time', {
      staticClass: "u-text-muted u-fs-12"
    }, [_vm._v(_vm._s(_vm._f("moment")(history.createdAt, 'from')) + " (" + _vm._s(history.user.email) + ")")]), _vm._v(" "), _c('div', {
      staticClass: "l-row history"
    }, [_c('div', {
      staticClass: "l-col-12@md"
    }, [_c('div', {
      staticClass: "l-row vertical-flex"
    }, [_c('div', {
      staticClass: "l-col-5@md"
    }, [_c('price', {
      attrs: {
        "price": history.oldPrice
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "l-col-2@md relative"
    }, [_c('i', {
      staticClass: "i-arrow icon-arrow-right center"
    })]), _vm._v(" "), _c('div', {
      staticClass: "l-col-5@md"
    }, [_c('price', {
      attrs: {
        "price": history.newPrice
      }
    })], 1)])])])])
  }), 0) : _vm._e(), _vm._v(" "), (!_vm.priceHistory.length) ? _c('div', {
    staticClass: "u-textCenter teste"
  }, [_vm._v("\n        Nenhum histórico de alteração de preço encontrado.\n      ")]) : _vm._e()]), _vm._v(" "), _c('footer', {
    staticClass: "c-modalCard__footer"
  }, [_c('button', {
    staticClass: "btn btn--info",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Fechar")])])])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-20877274","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/shared/ModalPriceHistory.vue
// module id = 2972
// module chunks = 0